import React, { useState } from 'react';
import {
  FieldsLayout,
  ModalShell,
  ReferralBlock,
  shade,
  submitLabel,
  usePublicFormFonts
} from './publicFormUi';

/**
 * CMS preview of the public popup modal (Figma SI<3> Forms).
 */
export default function FormPreview({ form }) {
  usePublicFormFonts();
  const [values, setValues] = useState({});
  const [referral, setReferral] = useState({ code: '', valid: false, partnerName: '', message: '', applying: false });
  const fields = Array.isArray(form?.fields) ? form.fields : [];
  const brand = form?.buttonColor || '#6B46FE';
  const setValue = (name, value) => setValues(v => ({ ...v, [name]: value }));

  return (
    <div style={{ background: 'rgba(7,8,14,.92)', padding: 24, borderRadius: 16 }}>
      <ModalShell title={form?.title || 'Untitled form'} description={form?.description} image={form?.image} preview>
        <FieldsLayout
          fields={fields}
          values={values}
          onChange={setValue}
          brandColor={brand}
          uploadUrl={`${process.env.REACT_APP_API_URL || ''}/api/upload`}
        />
        {form?.showReferral !== false ? (
        <div style={{ marginTop: 22 }}>
          <ReferralBlock
            referral={referral}
            onCodeChange={code => setReferral(current => ({ ...current, code, message: '' }))}
            onApply={() => setReferral(current => ({
              ...current,
              valid: String(current.code || '').length >= 4,
              partnerName: String(current.code || '').length >= 4 ? 'Preview' : '',
              message: String(current.code || '').length >= 4 ? '' : 'This code is not active. Please double-check it.'
            }))}
            onRemove={() => setReferral({ code: '', valid: false, partnerName: '', message: '', applying: false })}
            brandColor={brand}
          />
        </div>
        ) : null}
        <button
          type="button"
          style={{
            marginTop: 22,
            width: '100%',
            minHeight: 52,
            border: 0,
            borderRadius: 12,
            background: `linear-gradient(90deg, ${brand}, ${shade(brand, -36)})`,
            color: '#fff',
            fontSize: 15,
            fontWeight: 700,
            cursor: 'default'
          }}
        >
          {submitLabel(form)}
        </button>
        <div style={{ marginTop: 10, fontSize: 12, color: '#64748B', textAlign: 'center' }}>
          Preview only — use Test submit below to hit the real API
        </div>
      </ModalShell>
    </div>
  );
}
